// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg_VdbDC {
  position: fixed;
  height: 100vh;
  width: 100vw;
  background-color: var(--_00000020-background);
  top: 0;
  left: 0;
  z-index: 9;
}

.sendEmailModal_hHSGU {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 90%;
  max-width: 550px;
  height: 72vh;
  padding-bottom: 20px;
  overflow-y: scroll;
  background-color: var(--f5-background);
  z-index: 999;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  animation: scaleUp_GsaMk 300ms ease-out forwards;
  -webkit-animation: scaleUp_GsaMk 300ms ease-out forwards;
  transform: translate(50%, 50%) scale(1);
  -webkit-transform: translate(50%, 50%) scale(1);
  -moz-transform: translate(50%, 50%) scale(1);
  -ms-transform: translate(50%, 50%) scale(1);
  -o-transform: translate(50%, 50%) scale(1);
  @media (width<768px) {
    height: 100vh;
    box-sizing: border-box;
    width: 100vw;
    max-width: 100vw;
  }
}
.sendEmailModal_hHSGU::-webkit-scrollbar {
  display: none;
}


.sendEmailContent_AQTXQ {
  padding: 20px;
  width: 95%;
  margin: 0 auto;
  box-sizing: border-box;
  background-color: var(--white-color);
  border-radius: 20px;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  -ms-border-radius: 20px;
  -o-border-radius: 20px;
}

.infOptions_svenD {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  input,
  textarea {
    background-color: var(--f5-background);
    border: none;
    outline: none;
    padding: 10px;
  }
}

.modalContainer_IpaXK {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
}

.addFileEmail_o8mj6 {
  margin-top: 10px;
  display: flex;
  padding: 0 20px;
  height: fit-content;
  gap: 10px;
  p {
    margin: 0 auto;
  }
}

.file_YNZHD {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  box-sizing: border-box;
}

.addFileRow_hodgG {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.fileIcon_ELuXc {
  display: flex;
  align-items: center;
  gap: 5px;
  padding-left: 20px;

  .icon_VFrfm {
    height: 15px;
    width: 15px;
  }
}

.attach_tkObk {
  background-color: #233f39;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  border-radius: 15px 0 0 15px;
  -webkit-border-radius: 15px 0 0 15px;
  -moz-border-radius: 15px 0 0 15px;
  -ms-border-radius: 15px 0 0 15px;
  -o-border-radius: 15px 0 0 15px;
}

.delete_RJJbw {
  height: 20px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #dc3545;
  cursor: pointer;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  img {
    height: 10px;
    width: 10px;
  }
}
.addFileEmail_o8mj6 .titleFile_MxjwW {
  margin: 20px 0;
  font-weight: 500;
}
.scaleDown_S1i7s {
  animation: scaleDown_S1i7s 300ms ease-in forwards;
  -webkit-animation: scaleDown_S1i7s 300ms ease-in forwards;
}
@keyframes scaleUp_GsaMk {
  from {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }
  to {
    transform: translate(-50%, -50%) scale(1);
    -webkit-transform: translate(-50%, -50%) scale(1);
    -moz-transform: translate(-50%, -50%) scale(1);
    -ms-transform: translate(-50%, -50%) scale(1);
    -o-transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes scaleDown_S1i7s {
  from {
    transform: translate(-50%, -50%) scale(1);
  }
  to {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }
}

.seeBillContainer_DgMxS{
  position: relative;

  &:hover{
    .seeBillContent_NmFu4{
      display: flex;
    }
  }
  .seeBillContent_NmFu4{
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 10px 0;
    display: none;
    background-color: gray;
    color: var(--white-color);
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/SendEmailModal/SendEmailModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,6CAA6C;EAC7C,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,gDAA0C;EAC1C,wDAAkD;EAClD,uCAAuC;EACvC,+CAA+C;EAC/C,4CAA4C;EAC5C,2CAA2C;EAC3C,0CAA0C;EAC1C;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,UAAU;EACV,cAAc;EACd,sBAAsB;EACtB,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT;;IAEE,sCAAsC;IACtC,YAAY;IACZ,aAAa;IACb,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;;EAElB;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;EACjC,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iDAA2C;EAC3C,yDAAmD;AACrD;AACA;EACE;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;EACA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE,kBAAkB;;EAElB;IACE;MACE,aAAa;IACf;EACF;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;AACF","sourcesContent":[".bg {\n  position: fixed;\n  height: 100vh;\n  width: 100vw;\n  background-color: var(--_00000020-background);\n  top: 0;\n  left: 0;\n  z-index: 9;\n}\n\n.sendEmailModal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  width: 90%;\n  max-width: 550px;\n  height: 72vh;\n  padding-bottom: 20px;\n  overflow-y: scroll;\n  background-color: var(--f5-background);\n  z-index: 999;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  animation: scaleUp 300ms ease-out forwards;\n  -webkit-animation: scaleUp 300ms ease-out forwards;\n  transform: translate(50%, 50%) scale(1);\n  -webkit-transform: translate(50%, 50%) scale(1);\n  -moz-transform: translate(50%, 50%) scale(1);\n  -ms-transform: translate(50%, 50%) scale(1);\n  -o-transform: translate(50%, 50%) scale(1);\n  @media (width<768px) {\n    height: 100vh;\n    box-sizing: border-box;\n    width: 100vw;\n    max-width: 100vw;\n  }\n}\n.sendEmailModal::-webkit-scrollbar {\n  display: none;\n}\n\n\n.sendEmailContent {\n  padding: 20px;\n  width: 95%;\n  margin: 0 auto;\n  box-sizing: border-box;\n  background-color: var(--white-color);\n  border-radius: 20px;\n  -webkit-border-radius: 20px;\n  -moz-border-radius: 20px;\n  -ms-border-radius: 20px;\n  -o-border-radius: 20px;\n}\n\n.infOptions {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  input,\n  textarea {\n    background-color: var(--f5-background);\n    border: none;\n    outline: none;\n    padding: 10px;\n  }\n}\n\n.modalContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n}\n\n.addFileEmail {\n  margin-top: 10px;\n  display: flex;\n  padding: 0 20px;\n  height: fit-content;\n  gap: 10px;\n  p {\n    margin: 0 auto;\n  }\n}\n\n.file {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: fit-content;\n  box-sizing: border-box;\n}\n\n.addFileRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.fileIcon {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding-left: 20px;\n\n  .icon {\n    height: 15px;\n    width: 15px;\n  }\n}\n\n.attach {\n  background-color: #233f39;\n  width: fit-content;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50px;\n  border-radius: 15px 0 0 15px;\n  -webkit-border-radius: 15px 0 0 15px;\n  -moz-border-radius: 15px 0 0 15px;\n  -ms-border-radius: 15px 0 0 15px;\n  -o-border-radius: 15px 0 0 15px;\n}\n\n.delete {\n  height: 20px;\n  width: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #dc3545;\n  cursor: pointer;\n  border-radius: 50%;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  img {\n    height: 10px;\n    width: 10px;\n  }\n}\n.addFileEmail .titleFile {\n  margin: 20px 0;\n  font-weight: 500;\n}\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n  -webkit-animation: scaleDown 300ms ease-in forwards;\n}\n@keyframes scaleUp {\n  from {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n  to {\n    transform: translate(-50%, -50%) scale(1);\n    -webkit-transform: translate(-50%, -50%) scale(1);\n    -moz-transform: translate(-50%, -50%) scale(1);\n    -ms-transform: translate(-50%, -50%) scale(1);\n    -o-transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n@keyframes scaleDown {\n  from {\n    transform: translate(-50%, -50%) scale(1);\n  }\n  to {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n}\n\n.seeBillContainer{\n  position: relative;\n\n  &:hover{\n    .seeBillContent{\n      display: flex;\n    }\n  }\n  .seeBillContent{\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    padding: 10px 0;\n    display: none;\n    background-color: gray;\n    color: var(--white-color);\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg": `bg_VdbDC`,
	"sendEmailModal": `sendEmailModal_hHSGU`,
	"scaleUp": `scaleUp_GsaMk`,
	"sendEmailContent": `sendEmailContent_AQTXQ`,
	"infOptions": `infOptions_svenD`,
	"modalContainer": `modalContainer_IpaXK`,
	"addFileEmail": `addFileEmail_o8mj6`,
	"file": `file_YNZHD`,
	"addFileRow": `addFileRow_hodgG`,
	"fileIcon": `fileIcon_ELuXc`,
	"icon": `icon_VFrfm`,
	"attach": `attach_tkObk`,
	"delete": `delete_RJJbw`,
	"titleFile": `titleFile_MxjwW`,
	"scaleDown": `scaleDown_S1i7s`,
	"seeBillContainer": `seeBillContainer_DgMxS`,
	"seeBillContent": `seeBillContent_NmFu4`
};
export default ___CSS_LOADER_EXPORT___;
